import { supabase } from '../supabaseClient';

export const fetchProfiles = async () => {
  const { data, error } = await supabase.from('profiles').select('id, full_name').order('full_name', { ascending: true });
  if (error) {
    alert(`Error fetchProfiles: ${error.message}`);
    throw error;
  }
  return data;
};

export const fetchStaffProfiles = async () => {
  const { data, error } = await supabase.from('profiles').select('id, full_name').in('type', ['staff', 'admin']).order('full_name', { ascending: true });
  if (error) {
    alert(`Error fetchStaffProfiles: ${error.message}`);
    throw error;
  }
  return data;
};

// Público: profesionales (staff/admin) que tienen al menos un servicio cargado.
// Intenta primero con los campos de perfil público (bio/avatar_url/specialty);
// si esas columnas todavía no existen en la base, reintenta sin ellas para que
// la sección siga funcionando igual.
export const fetchPublicProfessionals = async () => {
  const richSelect = 'id, full_name, phone, email, bio, avatar_url, specialty, services!inner(id, title, price, duration)';
  const basicSelect = 'id, full_name, phone, email, services!inner(id, title, price, duration)';

  let { data, error } = await supabase.from('profiles').select(richSelect).in('type', ['staff', 'admin']);

  if (error) {
    ({ data, error } = await supabase.from('profiles').select(basicSelect).in('type', ['staff', 'admin']));
  }

  if (error) {
    console.error('Error fetchPublicProfessionals:', error.message);
    return [];
  }

  return data || [];
};

export const updateMyProfile = async (userId, fields) => {
  const { error } = await supabase.from('profiles').update(fields).eq('id', userId);
  if (error) {
    alert(`Error guardando perfil: ${error.message}`);
    throw error;
  }
  return true;
};

export const getUser = async () => {
  const { data, error } = await supabase.auth.getUser();
  if (error) {
    alert(`Error getUser: ${error.message}`);
    throw error;
  }
  return data;
};